import { Monitor, Laptop, Server, Router, Network, Share2, Plus } from 'lucide-react';
import useStore from '../lib/store';

const devices = [
  { type: 'pc', icon: Monitor, name: 'Computer', description: 'End device' },
  { type: 'laptop', icon: Laptop, name: 'Laptop', description: 'End device' },
  { type: 'server', icon: Server, name: 'Server', description: 'Service provider' },
  { type: 'router', icon: Router, name: 'Router', description: 'Network layer (L3)' },
  { type: 'switch', icon: Network, name: 'Switch', description: 'Data link layer (L2)' },
  { type: 'hub', icon: Share2, name: 'Hub', description: 'Physical layer (L1)' },
];

export default function DevicePalette() {
  const addDevice = useStore(state => state.addDevice);

  const handleClick = (deviceType) => {
    // Add device to center of canvas
    const centerX = window.innerWidth / 2 - 400;
    const centerY = window.innerHeight / 2 - 100;
    
    // Add random offset so devices don't stack
    const randomX = Math.random() * 100 - 50;
    const randomY = Math.random() * 100 - 50;
    
    addDevice(deviceType, centerX + randomX, centerY + randomY);
  };

  return (
    <div className="device-palette">
      <h3 className="device-palette-title">Add Devices</h3>
      <p className="device-palette-subtitle">Click to add to canvas</p>
      <div className="device-list">
        {devices.map(device => {
          const Icon = device.icon;
          return (
            <button
              key={device.type}
              className="device-item"
              onClick={() => handleClick(device.type)}
            >
              <div className="device-item-icon">
                <Icon size={24} />
              </div>
              <div className="device-item-info">
                <h4>{device.name}</h4>
                <p>{device.description}</p>
              </div>
              <div className="device-item-add">
                <Plus size={18} />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
